

import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Button, Container, Input, Row } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import InvoiceTab from './Demo2';

const Demo2 = () => {


    return (
        <React.Fragment>
            <div className='page-content'>
                <Container fluid>
                    <Col>
                        <BreadCrumb title="Invoice Scanner" pageTitle="Dashboard" />
                        <Card>
                            <CardBody>
                                <Row>
                                    
                                    <InvoiceTab />
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Demo2;